export enum context {
  CTA_DIGITAL_PYME = 'cuenta-digital',
  PUBLIC_SITE = 'public',
}
